export default function SellerStore() {
  return (
    <div className="py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <h1 className="font-western text-4xl text-cream mb-8">Seller Store</h1>
        <p className="text-text-secondary">Coming soon...</p>
      </div>
    </div>
  );
}
